import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLang = new BehaviorSubject<string>('en');
  public language$ = this.currentLang.asObservable();

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.detectGoogleTranslateChange();
  }

  // ✅ Manually set language from app (like profile or dropdown)
  setLanguage(lang: string): void {
    this.currentLang.next(lang);
  }

  getLanguage(): string {
    return this.currentLang.value;
  }

  resetBodyStyles(): void {
    const body = this.document.body;
    body.style.transform = 'none';
    body.style.top = '0';
  }

  // ✅ Watch for Google Translate changes
   detectGoogleTranslateChange(): void {
    const observer = new MutationObserver(() => {
       this.resetBodyStyles();
      const newLang = this.getSelectedLanguageFromCookie();
      if (newLang && newLang !== this.currentLang.value) {
        this.currentLang.next(newLang);
      }
    });

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  // ✅ Reads language code from Google Translate cookie
   getSelectedLanguageFromCookie(): string {
    const match = document.cookie.match(/googtrans=\/[^/]+\/([^;]+)/);
    return match ? match[1] : 'en';
  }
}
